module.exports = __webpack_public_path__ + "img/public-notification.569a0db0.svg";